import React from "react";
import {Link, useLocation} from "react-router-dom";
import {LoggedInRoutes, clusterIdFromPath} from "../../LoggedInRoutes";
import SystemEntityStatus from "../loggedin/clusters/ui/SystemEntityStatus";

/*
 * Small screen replacement for the navigation rail: a scrollable row of clusters and, below it, the pages of the
 * current cluster.
 */
export default function MobileNavigation({clusters, sidebar}) {

  const location = useLocation();
  const activeClusterId = clusterIdFromPath(location.pathname);

  if (!clusters) {
    return null;
  }

  return (
      <nav className="sidebar-sm d-md-none">
        <ul className="cluster-list">
          {clusters.map((cluster) => (
              <li key={cluster.uuid} className={cluster.uuid === activeClusterId ? "active" : ""}>
                <Link to={LoggedInRoutes.CLUSTERS.SHOW(cluster.uuid)}>
                  <SystemEntityStatus status={cluster.status} />
                  <span>{cluster.name}</span>
                </Link>
              </li>
          ))}

          <li>
            <Link to={LoggedInRoutes.CLUSTERS.MGMT.CREATE}>
              <i className="bx bx-plus" /> Add Cluster
            </Link>
          </li>
        </ul>

        {activeClusterId && sidebar ? <div className="cluster-subnav">{sidebar}</div> : null}
      </nav>
  )

}
